import type { MultilingualQuestion } from '../../types/multilingualQuestion';

// Multilingual version of Vehicle Documentation questions
export const vehicleDocumentationMultilingual: MultilingualQuestion[] = [
  {
    id: 'q-vd-1',
    text: {
      en: 'What documents must you carry when driving in the Netherlands?',
      nl: 'Welke documenten moet je bij je hebben bij het rijden in Nederland?',
      ar: 'ما المستندات التي يجب أن تحملها عند القيادة في هولندا؟'
    },
    options: [
      {
        id: 'q-vd-1o1',
        text: { en: 'Only driving license', nl: 'Alleen rijbewijs', ar: 'رخصة القيادة فقط' }
      },
      {
        id: 'q-vd-1o2',
        text: { en: 'Driving license and vehicle registration document', nl: 'Rijbewijs en kentekenbewijs', ar: 'رخصة القيادة ووثيقة تسجيل المركبة' }
      },
      {
        id: 'q-vd-1o3',
        text: { en: 'Driving license, vehicle registration, insurance certificate, and MOT certificate', nl: 'Rijbewijs, kentekenbewijs, verzekeringsbewijs en APK-certificaat', ar: 'رخصة القيادة، تسجيل المركبة، شهادة التأمين وشهادة الفحص الدوري' }
      }
    ],
    correctAnswerId: 'q-vd-1o3',
    explanation: {
      en: 'You must carry your driving license, vehicle registration document (kentekenbewijs), insurance certificate, and MOT certificate (APK) when driving. (RVV 1990 art. 108)',
      nl: 'Je moet je rijbewijs, kentekenbewijs, verzekeringsbewijs en APK-certificaat bij je hebben bij het rijden. (RVV 1990 art. 108)',
      ar: 'يجب أن تحمل رخصة القيادة، وثيقة تسجيل المركبة (kentekenbewijs)، شهادة التأمين وشهادة الفحص الدوري (APK) عند القيادة. (RVV 1990 المادة 108)'
    },
    subject: 'Vehicle Documentation'
  },
  {
    id: 'q-vd-2',
    text: {
      en: 'What is the APK (Algemene Periodieke Keuring)?',
      nl: 'Wat is de APK (Algemene Periodieke Keuring)?',
      ar: 'ما هو APK (الفحص الدوري العام)؟'
    },
    options: [
      {
        id: 'q-vd-2o1',
        text: { en: 'Annual vehicle insurance check', nl: 'Jaarlijkse voertuigverzekeringcontrole', ar: 'فحص تأمين المركبة السنوي' }
      },
      {
        id: 'q-vd-2o2',
        text: { en: 'Annual vehicle safety and emissions test', nl: 'Jaarlijkse voertuigveiligheids- en emissietest', ar: 'اختبار السلامة والانبعاثات السنوي للمركبة' }
      },
      {
        id: 'q-vd-2o3',
        text: { en: 'Annual driving license renewal', nl: 'Jaarlijkse rijbewijsverlenging', ar: 'تجديد رخصة القيادة السنوي' }
      }
    ],
    correctAnswerId: 'q-vd-2o2',
    explanation: {
      en: 'APK (Algemene Periodieke Keuring) is the annual vehicle safety and emissions test that all vehicles must pass to be roadworthy.',
      nl: 'De APK (Algemene Periodieke Keuring) is de jaarlijkse voertuigveiligheids- en emissietest die alle voertuigen moeten doorstaan om rijwaardig te zijn.',
      ar: 'APK (Algemene Periodieke Keuring) هو اختبار السلامة والانبعاثات السنوي الذي يجب أن تجتازه جميع المركبات لتكون صالحة للطريق.'
    },
    subject: 'Vehicle Documentation'
  },
  {
    id: 'q-vd-3',
    text: {
      en: 'How often must a new car have an APK test?',
      nl: 'Hoe vaak moet een nieuwe auto een APK-keuring ondergaan?',
      ar: 'كم مرة يجب أن تخضع السيارة الجديدة لاختبار APK؟'
    },
    options: [
      {
        id: 'q-vd-3o1',
        text: { en: 'Every year', nl: 'Elk jaar', ar: 'كل سنة' }
      },
      {
        id: 'q-vd-3o2',
        text: { en: 'Every 2 years', nl: 'Elke 2 jaar', ar: 'كل سنتين' }
      },
      {
        id: 'q-vd-3o3',
        text: { en: 'Every 3 years', nl: 'Elke 3 jaar', ar: 'كل 3 سنوات' }
      }
    ],
    correctAnswerId: 'q-vd-3o3',
    explanation: {
      en: 'A new car must have its first APK test after 3 years, then every year thereafter.',
      nl: 'Een nieuwe auto moet na 3 jaar zijn eerste APK-keuring ondergaan, daarna jaarlijks.',
      ar: 'يجب أن تخضع السيارة الجديدة لاختبار APK الأول بعد 3 سنوات، ثم كل سنة بعد ذلك.'
    },
    subject: 'Vehicle Documentation'
  },
  {
    id: 'q-vd-4',
    text: {
      en: 'What happens if you drive without valid insurance?',
      nl: 'Wat gebeurt er als je rijdt zonder geldige verzekering?',
      ar: 'ماذا يحدث إذا قدت بدون تأمين ساري؟'
    },
    options: [
      {
        id: 'q-vd-4o1',
        text: { en: 'Warning only', nl: 'Alleen waarschuwing', ar: 'تحذير فقط' }
      },
      {
        id: 'q-vd-4o2',
        text: { en: 'Fine of €140', nl: 'Boete van €140', ar: 'غرامة 140 يورو' }
      },
      {
        id: 'q-vd-4o3',
        text: { en: 'Heavy fine and possible vehicle confiscation', nl: 'Zware boete en mogelijke inbeslagname van het voertuig', ar: 'غرامة ثقيلة واحتمال مصادرة المركبة' }
      }
    ],
    correctAnswerId: 'q-vd-4o3',
    explanation: {
      en: 'Driving without valid insurance results in a heavy fine and possible vehicle confiscation. It is a serious offense. (RVV 1990 art. 107)',
      nl: 'Rijden zonder geldige verzekering resulteert in een zware boete en mogelijke inbeslagname van het voertuig. Het is een ernstig vergrijp. (RVV 1990 art. 107)',
      ar: 'القيادة بدون تأمين صالح تؤدي إلى غرامة ثقيلة واحتمال مصادرة المركبة. إنها جريمة خطيرة. (RVV 1990 المادة 107)'
    },
    subject: 'Vehicle Documentation'
  },
  {
    id: 'q-vd-5',
    text: {
      en: 'What is the minimum insurance coverage required in the Netherlands?',
      nl: 'Wat is de minimale verzekeringsdekking die in Nederland vereist is?',
      ar: 'ما الحد الأدنى من التغطية التأمينية المطلوبة في هولندا؟'
    },
    options: [
      {
        id: 'q-vd-5o1',
        text: { en: 'Third-party liability only', nl: 'Alleen aansprakelijkheidsverzekering', ar: 'تأمين المسؤولية تجاه الغير فقط' }
      },
      {
        id: 'q-vd-5o2',
        text: { en: 'Third-party liability and theft', nl: 'Aansprakelijkheidsverzekering en diefstal', ar: 'تأمين المسؤولية والسرقة' }
      },
      {
        id: 'q-vd-5o3',
        text: { en: 'Comprehensive coverage', nl: 'Allrisk dekking', ar: 'التغطية الشاملة' }
      }
    ],
    correctAnswerId: 'q-vd-5o1',
    explanation: {
      en: 'The minimum insurance coverage required in the Netherlands is third-party liability insurance (WA-verzekering). (RVV 1990 art. 107)',
      nl: 'De minimale verzekeringsdekking die in Nederland vereist is, is de aansprakelijkheidsverzekering (WA-verzekering). (RVV 1990 art. 107)',
      ar: 'الحد الأدنى من التغطية التأمينية المطلوبة في هولندا هو تأمين المسؤولية تجاه الغير (WA-verzekering). (RVV 1990 المادة 107)'
    },
    subject: 'Vehicle Documentation'
  },
  {
    id: 'q-vd-6',
    text: {
      en: 'What should you do if you lose your driving license?',
      nl: 'Wat moet je doen als je rijbewijs kwijtraakt?',
      ar: 'ماذا يجب فعله إذا فقدت رخصة قيادتك؟'
    },
    options: [
      {
        id: 'q-vd-6o1',
        text: { en: 'Continue driving normally', nl: 'Gewoon doorrijden', ar: 'الاستمرار في القيادة بشكل طبيعي' }
      },
      {
        id: 'q-vd-6o2',
        text: { en: 'Report it to the police and apply for a replacement', nl: 'Aangifte doen bij de politie en een vervangend rijbewijs aanvragen', ar: 'الإبلاغ عن الأمر للشرطة والتقدم للحصول على بديل' }
      },
      {
        id: 'q-vd-6o3',
        text: { en: 'Wait until you find it', nl: 'Wachten totdat je het vindt', ar: 'الانتظار حتى تجده' }
      }
    ],
    correctAnswerId: 'q-vd-6o2',
    explanation: {
      en: 'If you lose your driving license, you should report it to the police and apply for a replacement at your local municipality.',
      nl: 'Als je rijbewijs kwijtraakt, moet je aangifte doen bij de politie en een vervangend rijbewijs aanvragen bij je gemeente.',
      ar: 'إذا فقدت رخصة قيادتك، يجب الإبلاغ عن ذلك للشرطة والتقدم للحصول على بديل من بلديتك المحلية.'
    },
    subject: 'Vehicle Documentation'
  },
  {
    id: 'q-vd-7',
    text: {
      en: 'What is the penalty for driving without a valid driving license?',
      nl: 'Wat is de straf voor rijden zonder geldig rijbewijs?',
      ar: 'ما عقوبة القيادة بدون رخصة قيادة صالحة؟'
    },
    options: [
      {
        id: 'q-vd-7o1',
        text: { en: 'Warning only', nl: 'Alleen waarschuwing', ar: 'تحذير فقط' }
      },
      {
        id: 'q-vd-7o2',
        text: { en: 'Fine of €140', nl: 'Boete van €140', ar: 'غرامة 140 يورو' }
      },
      {
        id: 'q-vd-7o3',
        text: { en: 'Heavy fine and possible imprisonment', nl: 'Zware boete en mogelijke gevangenisstraf', ar: 'غرامة ثقيلة واحتمال السجن' }
      }
    ],
    correctAnswerId: 'q-vd-7o3',
    explanation: {
      en: 'Driving without a valid driving license is a serious offense that can result in a heavy fine and possible imprisonment.',
      nl: 'Rijden zonder geldig rijbewijs is een ernstig vergrijp dat kan leiden tot een zware boete en mogelijke gevangenisstraf.',
      ar: 'القيادة بدون رخصة قيادة صالحة جريمة خطيرة يمكن أن تؤدي إلى غرامة ثقيلة واحتمال السجن.'
    },
    subject: 'Vehicle Documentation'
  },
  {
    id: 'q-vd-8',
    text: {
      en: 'What should you do if your vehicle registration document is stolen?',
      nl: 'Wat moet je doen als je kentekenbewijs gestolen is?',
      ar: 'ماذا يجب فعله إذا سرقت وثيقة تسجيل مركبتك؟'
    },
    options: [
      {
        id: 'q-vd-8o1',
        text: { en: 'Continue driving normally', nl: 'Gewoon doorrijden', ar: 'الاستمرار في القيادة بشكل طبيعي' }
      },
      {
        id: 'q-vd-8o2',
        text: { en: 'Report it to the police and apply for a replacement', nl: 'Aangifte doen bij de politie en een vervangend document aanvragen', ar: 'الإبلاغ للشرطة والتقدم للحصول على بديل' }
      },
      {
        id: 'q-vd-8o3',
        text: { en: 'Wait until you find it', nl: 'Wachten totdat je het vindt', ar: 'الانتظار حتى تجده' }
      }
    ],
    correctAnswerId: 'q-vd-8o2',
    explanation: {
      en: 'If your vehicle registration document is stolen, you should report it to the police and apply for a replacement at the RDW.',
      nl: 'Als je kentekenbewijs gestolen is, moet je aangifte doen bij de politie en een vervangend document aanvragen bij de RDW.',
      ar: 'إذا سرقت وثيقة تسجيل مركبتك، يجب الإبلاغ للشرطة والتقدم للحصول على بديل من RDW.'
    },
    subject: 'Vehicle Documentation'
  },
  {
    id: 'q-vd-9',
    text: {
      en: 'What is the RDW (Rijksdienst voor het Wegverkeer)?',
      nl: 'Wat is de RDW (Rijksdienst voor het Wegverkeer)?',
      ar: 'ما هو RDW (خدمة الطرق الوطنية الهولندية)؟'
    },
    options: [
      {
        id: 'q-vd-9o1',
        text: { en: 'Dutch driving school association', nl: 'Nederlandse rijschoolvereniging', ar: 'رابطة مدارس القيادة الهولندية' }
      },
      {
        id: 'q-vd-9o2',
        text: { en: 'Dutch vehicle registration and licensing authority', nl: 'Nederlandse voertuigregistratie- en licentieautoriteit', ar: 'سلطة تسجيل المركبات ومنح التراخيص الهولندية' }
      },
      {
        id: 'q-vd-9o3',
        text: { en: 'Dutch insurance company', nl: 'Nederlandse verzekeringsmaatschappij', ar: 'شركة التأمين الهولندية' }
      }
    ],
    correctAnswerId: 'q-vd-9o2',
    explanation: {
      en: 'The RDW (Rijksdienst voor het Wegverkeer) is the Dutch vehicle registration and licensing authority responsible for vehicle documentation.',
      nl: 'De RDW (Rijksdienst voor het Wegverkeer) is de Nederlandse voertuigregistratie- en licentieautoriteit die verantwoordelijk is voor voertuigdocumentatie.',
      ar: 'RDW (Rijksdienst voor het Wegverkeer) هي سلطة تسجيل المركبات ومنح التراخيص الهولندية المسؤولة عن وثائق المركبات.'
    },
    subject: 'Vehicle Documentation'
  },
  {
    id: 'q-vd-10',
    text: {
      en: 'What should you do if you buy a used car?',
      nl: 'Wat moet je doen als je een tweedehands auto koopt?',
      ar: 'ماذا يجب فعله إذا اشتريت سيارة مستعملة؟'
    },
    options: [
      {
        id: 'q-vd-10o1',
        text: { en: 'Transfer ownership immediately', nl: 'Eigendom direct overdragen', ar: 'نقل الملكية فورا' }
      },
      {
        id: 'q-vd-10o2',
        text: { en: 'Transfer ownership within 14 days', nl: 'Eigendom binnen 14 dagen overdragen', ar: 'نقل الملكية خلال 14 يوما' }
      },
      {
        id: 'q-vd-10o3',
        text: { en: 'Transfer ownership within 30 days', nl: 'Eigendom binnen 30 dagen overdragen', ar: 'نقل الملكية خلال 30 يوما' }
      }
    ],
    correctAnswerId: 'q-vd-10o2',
    explanation: {
      en: 'When you buy a used car, you must transfer ownership within 14 days at the RDW or a post office.',
      nl: 'Wanneer je een tweedehands auto koopt, moet je het eigendom binnen 14 dagen overdragen bij de RDW of een postkantoor.',
      ar: 'عند شراء سيارة مستعملة، يجب نقل الملكية خلال 14 يوما في RDW أو مكتب البريد.'
    },
    subject: 'Vehicle Documentation'
  },
  {
    id: 'q-vd-11',
    text: {
      en: 'What happens if you fail to transfer vehicle ownership on time?',
      nl: 'Wat gebeurt er als je het eigendom van een voertuig niet op tijd overdraagt?',
      ar: 'ماذا يحدث إذا فشلت في نقل ملكية المركبة في الوقت المحدد؟'
    },
    options: [
      {
        id: 'q-vd-11o1',
        text: { en: 'No penalty', nl: 'Geen boete', ar: 'لا عقوبة' }
      },
      {
        id: 'q-vd-11o2',
        text: { en: 'Small fine', nl: 'Kleine boete', ar: 'غرامة صغيرة' }
      },
      {
        id: 'q-vd-11o3',
        text: { en: 'Fine of €340', nl: 'Boete van €340', ar: 'غرامة 340 يورو' }
      }
    ],
    correctAnswerId: 'q-vd-11o3',
    explanation: {
      en: 'Failing to transfer vehicle ownership within 14 days results in a fine of €340.',
      nl: 'Als je het eigendom van een voertuig niet binnen 14 dagen overdraagt, resulteert dit in een boete van €340.',
      ar: 'الفشل في نقل ملكية المركبة خلال 14 يوما يؤدي إلى غرامة 340 يورو.'
    },
    subject: 'Vehicle Documentation'
  },
  {
    id: 'q-vd-12',
    text: {
      en: 'What should you do if you move to a different address?',
      nl: 'Wat moet je doen als je naar een ander adres verhuist?',
      ar: 'ماذا يجب فعله إذا انتقلت إلى عنوان مختلف؟'
    },
    options: [
      {
        id: 'q-vd-12o1',
        text: { en: 'Update your driving license address', nl: 'Je rijbewijsadres bijwerken', ar: 'تحديث عنوان رخصة قيادتك' }
      },
      {
        id: 'q-vd-12o2',
        text: { en: 'Update your vehicle registration address', nl: 'Je kentekenbewijsadres bijwerken', ar: 'تحديث عنوان تسجيل مركبتك' }
      },
      {
        id: 'q-vd-12o3',
        text: { en: 'Update both driving license and vehicle registration addresses', nl: 'Zowel rijbewijs- als kentekenbewijsadres bijwerken', ar: 'تحديث عنواني رخصة القيادة وتسجيل المركبة معا' }
      }
    ],
    correctAnswerId: 'q-vd-12o3',
    explanation: {
      en: 'When you move to a different address, you must update both your driving license and vehicle registration addresses at your local municipality.',
      nl: 'Wanneer je naar een ander adres verhuist, moet je zowel je rijbewijs- als kentekenbewijsadres bijwerken bij je gemeente.',
      ar: 'عند الانتقال إلى عنوان مختلف، يجب تحديث عنواني رخصة قيادتك وتسجيل مركبتك في بلديتك المحلية.'
    },
    subject: 'Vehicle Documentation'
  },
  {
    id: 'q-vd-13',
    text: {
      en: 'What is the MOT (APK) inspection for vehicles in the Netherlands?',
      nl: 'Wat is de APK-keuring voor voertuigen in Nederland?',
      ar: 'ما هو فحص APK للمركبات في هولندا؟'
    },
    options: [
      {
        id: 'q-vd-13o1',
        text: { en: 'Annual insurance inspection', nl: 'Jaarlijkse verzekeringskeuring', ar: 'فحص التأمين السنوي' }
      },
      {
        id: 'q-vd-13o2',
        text: { en: 'Biennial roadworthiness and emissions inspection', nl: 'Tweejaarlijkse rij- en emissiewaardigheidskeuring', ar: 'فحص الصلاحية للطريق والانبعاثات كل سنتين' }
      },
      {
        id: 'q-vd-13o3',
        text: { en: 'Monthly brake inspection', nl: 'Maandelijkse remkeuring', ar: 'فحص الفرامل الشهري' }
      }
    ],
    correctAnswerId: 'q-vd-13o2',
    explanation: {
      en: 'The APK (Algemene Periodieke Keuring) is the biennial roadworthiness and emissions inspection required for all vehicles in the Netherlands.',
      nl: 'De APK (Algemene Periodieke Keuring) is de tweejaarlijkse rij- en emissiewaardigheidskeuring die vereist is voor alle voertuigen in Nederland.',
      ar: 'APK (Algemene Periodieke Keuring) هو فحص الصلاحية للطريق والانبعاثات الدوري المطلوب لجميع المركبات في هولندا.'
    },
    subject: 'Vehicle Documentation'
  },
  {
    id: 'q-vd-14',
    text: {
      en: 'What documents must you carry while driving a vehicle?',
      nl: 'Welke documenten moet je bij je hebben tijdens het rijden?',
      ar: 'ما المستندات التي يجب حملها أثناء قيادة مركبة؟'
    },
    options: [
      {
        id: 'q-vd-14o1',
        text: { en: 'Only your driving license', nl: 'Alleen je rijbewijs', ar: 'رخصة قيادتك فقط' }
      },
      {
        id: 'q-vd-14o2',
        text: { en: 'Driving license, vehicle registration, and insurance documents', nl: 'Rijbewijs, kentekenbewijs en verzekeringsdocumenten', ar: 'رخصة القيادة، تسجيل المركبة، ووثائق التأمين' }
      },
      {
        id: 'q-vd-14o3',
        text: { en: 'Only vehicle registration', nl: 'Alleen kentekenbewijs', ar: 'تسجيل المركبة فقط' }
      }
    ],
    correctAnswerId: 'q-vd-14o2',
    explanation: {
      en: 'While driving, you must carry your valid driving license, vehicle registration document, and proof of insurance. Present these upon request to law enforcement. (RVV 1990 art. 108)',
      nl: 'Tijdens het rijden moet je je geldig rijbewijs, kentekenbewijs en verzekeringsbewijs bij je hebben. Je moet deze op verzoek tonen aan de politie. (RVV 1990 art. 108)',
      ar: 'أثناء القيادة، يجب حمل رخصة قيادتك الصالحة، وثيقة تسجيل المركبة، وإثبات التأمين. قدمها عند الطلب لجهات إنفاذ القانون. (RVV 1990 المادة 108)'
    },
    subject: 'Vehicle Documentation'
  },
  {
    id: 'q-vd-15',
    text: {
      en: 'What is a GB plate on a vehicle registration plate?',
      nl: 'Wat is een GB-plaat op een kentekenplaat?',
      ar: 'ما معنى لوحة GB على لوحة ترقيم المركبة؟'
    },
    options: [
      {
        id: 'q-vd-15o1',
        text: { en: 'Indicates the vehicle is from Germany', nl: 'Geeft aan dat het voertuig uit Duitsland komt', ar: 'يشير إلى أن المركبة من ألمانيا' }
      },
      {
        id: 'q-vd-15o2',
        text: { en: 'Indicates the vehicle is from Great Britain or the UK', nl: 'Geeft aan dat het voertuig uit Groot-Brittannië of het VK komt', ar: 'يشير إلى أن المركبة من بريطانيا أو المملكة المتحدة' }
      },
      {
        id: 'q-vd-15o3',
        text: { en: 'Indicates the vehicle is an electric vehicle', nl: 'Geeft aan dat het voertuig een elektrisch voertuig is', ar: 'يشير إلى أن المركبة كهربائية' }
      }
    ],
    correctAnswerId: 'q-vd-15o2',
    explanation: {
      en: 'The GB identifier on a registration plate indicates the vehicle is from Great Britain or the UK, displayed on the left side of the plate.',
      nl: 'De GB-aanduiding op een kentekenplaat geeft aan dat het voertuig uit Groot-Brittannië of het VK komt, weergegeven aan de linkerkant van de plaat.',
      ar: 'رمز GB على لوحة الترقيم يشير إلى أن المركبة من بريطانيا أو المملكة المتحدة، ويظهر على الجانب الأيسر من اللوحة.'
    },
    subject: 'Vehicle Documentation'
  },
  {
    id: 'q-vd-16',
    text: {
      en: 'How long is a driving license valid in the Netherlands?',
      nl: 'Hoe lang is een rijbewijs geldig in Nederland?',
      ar: 'ما مدة صلاحية رخصة القيادة في هولندا؟'
    },
    options: [
      {
        id: 'q-vd-16o1',
        text: { en: '5 years', nl: '5 jaar', ar: '5 سنوات' }
      },
      {
        id: 'q-vd-16o2',
        text: { en: '10 years', nl: '10 jaar', ar: '10 سنوات' }
      },
      {
        id: 'q-vd-16o3',
        text: { en: 'Varies by age; 5 years under 45, 10 years from 45 and older', nl: 'Varieert naar leeftijd; 5 jaar onder de 45, 10 jaar vanaf 45 jaar en ouder', ar: 'يختلف حسب العمر؛ 5 سنوات لمن هم دون 45 عاما، و10 سنوات لمن هم 45 عاما أو أكبر' }
      }
    ],
    correctAnswerId: 'q-vd-16o3',
    explanation: {
      en: 'Dutch driving licenses are valid for 5 years if the holder is under 45, and for 10 years if 45 or older. After this period, the license must be renewed.',
      nl: 'Nederlandse rijbewijzen zijn 5 jaar geldig als de houder jonger is dan 45, en 10 jaar als de houder 45 of ouder is. Na deze periode moet het rijbewijs worden verlengd.',
      ar: 'رخص القيادة الهولندية صالحة لمدة 5 سنوات إذا كان حاملها دون 45 عاما، و10 سنوات إذا كان 45 عاما أو أكبر. بعد هذه الفترة يجب تجديد الرخصة.'
    },
    subject: 'Vehicle Documentation'
  },
  {
    id: 'q-vd-17',
    text: {
      en: 'What is third-party liability insurance?',
      nl: 'Wat is een aansprakelijkheidsverzekering (WA)?',
      ar: 'ما هو تأمين المسؤولية تجاه الغير؟'
    },
    options: [
      {
        id: 'q-vd-17o1',
        text: { en: 'Insurance covering damage to your own vehicle only', nl: 'Verzekering die alleen schade aan je eigen voertuig dekt', ar: 'تأمين يغطي الأضرار التي تلحق بمركبتك فقط' }
      },
      {
        id: 'q-vd-17o2',
        text: { en: 'Mandatory insurance covering damage or injury caused to other people', nl: 'Verplichte verzekering die schade of letsel aan anderen dekt', ar: 'تأمين إلزامي يغطي الأضرار أو الإصابات التي تسببها للآخرين' }
      },
      {
        id: 'q-vd-17o3',
        text: { en: 'Insurance covering medical expenses only', nl: 'Verzekering die alleen medische kosten dekt', ar: 'تأمين يغطي النفقات الطبية فقط' }
      }
    ],
    correctAnswerId: 'q-vd-17o2',
    explanation: {
      en: 'Third-party liability insurance is the mandatory minimum insurance in the Netherlands that covers damage or injuries you cause to other people. It does not cover damage to your own vehicle. (RVV 1990 art. 107)',
      nl: 'Aansprakelijkheidsverzekering (WA) is de verplichte minimumverzekering in Nederland die schade of letsel dekt dat je aan anderen veroorzaakt. Het dekt geen schade aan je eigen voertuig. (RVV 1990 art. 107)',
      ar: 'تأمين المسؤولية تجاه الغير هو الحد الأدنى الإلزامي للتأمين في هولندا الذي يغطي الأضرار أو الإصابات التي تسببها للآخرين. لا يغطي الأضرار التي تلحق بمركبتك. (RVV 1990 المادة 107)'
    },
    subject: 'Vehicle Documentation'
  },
  {
    id: 'q-vd-18',
    text: {
      en: 'What should you do if your insurance policy expires while you are on vacation abroad?',
      nl: 'Wat moet je doen als je verzekeringspolis verloopt terwijl je op vakantie bent in het buitenland?',
      ar: 'ماذا يجب فعله إذا انتهت صلاحية وثيقة التأمين أثناء وجودك في إجازة خارج البلاد؟'
    },
    options: [
      {
        id: 'q-vd-18o1',
        text: { en: 'Continue driving; you are still covered', nl: 'Gewoon doorrijden; je bent nog gedekt', ar: 'الاستمرار في القيادة؛ أنت لا تزال مؤمنا' }
      },
      {
        id: 'q-vd-18o2',
        text: { en: 'Stop driving immediately; you are not covered', nl: 'Onmiddellijk stoppen met rijden; je bent niet meer gedekt', ar: 'توقف فورا؛ أنت لست مؤمنا' }
      },
      {
        id: 'q-vd-18o3',
        text: { en: 'Contact your insurer to arrange temporary coverage immediately', nl: 'Neem onmiddellijk contact op met je verzekeraar om tijdelijke dekking te regelen', ar: 'اتصل بشركة التأمين فورا لترتيب تغطية مؤقتة' }
      }
    ],
    correctAnswerId: 'q-vd-18o3',
    explanation: {
      en: 'If your insurance expires while abroad, you must immediately contact your insurer to arrange temporary coverage. Driving without valid insurance is illegal.',
      nl: 'Als je verzekering verloopt terwijl je in het buitenland bent, moet je onmiddellijk contact opnemen met je verzekeraar om tijdelijke dekking te regelen. Rijden zonder geldige verzekering is illegaal.',
      ar: 'إذا انتهت صلاحية تأمينك خارج البلاد، يجب الاتصال فورا بشركة التأمين لترتيب تغطية مؤقتة. القيادة بدون تأمين صالح غير قانونية.'
    },
    subject: 'Vehicle Documentation'
  },
  {
    id: 'q-vd-19',
    text: {
      en: 'What is a green card for vehicle insurance?',
      nl: 'Wat is een groene kaart voor voertuigverzekering?',
      ar: 'ما هي البطاقة الخضراء لتأمين المركبة؟'
    },
    options: [
      {
        id: 'q-vd-19o1',
        text: { en: 'A card showing your driving license is valid', nl: 'Een kaart die aantoont dat je rijbewijs geldig is', ar: 'بطاقة تثبت صلاحية رخصة قيادتك' }
      },
      {
        id: 'q-vd-19o2',
        text: { en: 'International insurance certification for driving abroad', nl: 'Internationale verzekeringscertificering voor rijden in het buitenland', ar: 'شهادة تأمين دولية للقيادة في الخارج' }
      },
      {
        id: 'q-vd-19o3',
        text: { en: 'A card showing your APK inspection is valid', nl: 'Een kaart die aantoont dat je APK-keuring geldig is', ar: 'بطاقة تثبت صلاحية فحص APK' }
      }
    ],
    correctAnswerId: 'q-vd-19o2',
    explanation: {
      en: 'A green card is international insurance certification that proves your vehicle has third-party liability insurance valid in other countries. Many insurers include it automatically.',
      nl: 'Een groene kaart is een internationale verzekeringscertificering die bewijst dat je voertuig een aansprakelijkheidsverzekering heeft die geldig is in andere landen. Veel verzekeraars verstrekken deze automatisch.',
      ar: 'البطاقة الخضراء هي شهادة تأمين دولية تثبت أن مركبتك مؤمنة بتأمين مسؤولية تجاه الغير ساري في دول أخرى. كثير من شركات التأمين تشملها تلقائيا.'
    },
    subject: 'Vehicle Documentation'
  },
  {
    id: 'q-vd-20',
    text: {
      en: 'What penalty applies if you drive without valid insurance?',
      nl: 'Welke straf staat er op rijden zonder geldige verzekering?',
      ar: 'ما العقوبة التي تطبق على القيادة بدون تأمين صالح؟'
    },
    options: [
      {
        id: 'q-vd-20o1',
        text: { en: 'Warning only', nl: 'Alleen waarschuwing', ar: 'تحذير فقط' }
      },
      {
        id: 'q-vd-20o2',
        text: { en: 'Fine starting from €790 and possible vehicle impoundment', nl: 'Boete vanaf €790 en mogelijke inbeslagname van het voertuig', ar: 'غرامة تبدأ من 790 يورو واحتمال مصادرة المركبة' }
      },
      {
        id: 'q-vd-20o3',
        text: { en: 'Fine of €50', nl: 'Boete van €50', ar: 'غرامة 50 يورو' }
      }
    ],
    correctAnswerId: 'q-vd-20o2',
    explanation: {
      en: 'Driving without valid insurance results in a fine starting from €790, possible points on your license, and potential vehicle impoundment. (RVV 1990 art. 107)',
      nl: 'Rijden zonder geldige verzekering resulteert in een boete vanaf €790, mogelijke punten op je rijbewijs en mogelijke inbeslagname van het voertuig. (RVV 1990 art. 107)',
      ar: 'القيادة بدون تأمين صالح تؤدي إلى غرامة تبدأ من 790 يورو، واحتمال نقاط على رخصتك، ومصادرة المركبة. (RVV 1990 المادة 107)'
    },
    subject: 'Vehicle Documentation'
  }
];
